import React, { useEffect, useState } from 'react';
import ApacheEcharts from '../../ApacheEcharts';
import "./GraficoMedidor.css";

function GraficoMedidor({ dadosGrafico }) {

    const { titulo, realizado, ideal, meta, projetado, percentualRealizadoMeta, percentualProjetadoMeta } = dadosGrafico;

    const [option, setOption] = useState({});
    const style = { width: "100%", height: "250px", padding: "15px" };

    useEffect(() => {
        const option = {
            color: ['#165BAA', '#1AB394'],
            series: [{
                type: 'gauge',
                startAngle: 90,
                endAngle: -266.8,
                radius: '75%',
                animationDuration: 3000,
                animationDurationUpdate: 3000,
                min: 0,
                max: 120,
                pointer: {
                    show: false
                },
                progress: {
                    show: true,
                    overlap: false,
                    roundCap: true,
                    clip: false,
                    itemStyle: {
                        borderWidth: 4,
                        borderColor: 'white'
                    }
                },
                axisLine: {
                    lineStyle: {
                        width: 20
                    }
                },
                splitLine: {
                    distance: -25,
                    length: 5,
                    lineStyle: {
                        color: 'black',
                        width: 1
                    }
                },
                axisTick: {
                    show: false
                },
                axisLabel: {
                    distance: 0,
                    color: 'black',
                    fontSize: 10
                },
                data: [
                    {
                        value: percentualRealizadoMeta,
                        name: 'Realizado',
                        title: {
                            offsetCenter: ['0%', '-40%'],
                            color: 'black'
                        },
                        detail: {
                            valueAnimation: true,
                            offsetCenter: ['0%', '-20%'],
                            backgroundColor: '#cfe5ff'
                        }
                    },
                    {
                        value: percentualProjetadoMeta,
                        name: 'Projetado',
                        title: {
                            offsetCenter: ['0%', '10%'],
                            color: 'black'
                        },
                        detail: {
                            valueAnimation: true,
                            offsetCenter: ['0%', '30%'],
                            backgroundColor: '#d7fcf4'
                        }
                    }
                ],
                title: {
                    fontSize: 10
                },
                detail: {
                    width: 'auto',
                    height: 12,
                    fontSize: 10,
                    borderColor: 'inherit',
                    borderRadius: 3,
                    borderWidth: 0.5,
                    formatter: '{value}%'
                }
            }]
        }

        setOption(option);

    }, [percentualRealizadoMeta, percentualProjetadoMeta]);

    function formatarMoeda(valor) {
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        }).format(valor);
    }

    return (
        <>
            {realizado > 0 ? (
                <div className='card-medidor'>
                    <div className='card-header-medidor font-titulo-medidor'>
                        <span className='text-[9px]' style={{ color: '#888888' }}>Mensal</span>
                        <h3 className='uppercase'>{titulo}</h3>
                        <div className='text-[10px]'>Realizado</div>
                        <div className='flex-row-medidor' style={{ justifyContent: 'space-between' }}>
                            <div className='text-[15px]'>{formatarMoeda(realizado)}</div>
                            <div className='bol-real'></div>
                        </div>
                    </div>
                    <ApacheEcharts option={option} style={style} />
                    <div className='flex-row-medidor' style={{ padding: '20px' }}>
                        <div className='font-legend'>
                            <div className='flex-row-medidor'>
                                <div className='bol-ideal'></div>
                                Ideal
                            </div>
                            <div style={{ marginLeft: '15px' }}>{formatarMoeda(ideal)}</div>
                        </div>
                        <div className='font-legend'>
                            <div className='flex-row-medidor'>
                                <div className='bol-meta'></div>
                                Meta
                            </div>
                            <div style={{ marginLeft: '15px' }}>{formatarMoeda(meta)}</div>
                        </div>
                        <div className='font-legend'>
                            <div className='flex-row-medidor'>
                                <div className='bol-projetado'></div>
                                Projetado
                            </div>
                            <div style={{ marginLeft: '15px' }}>{formatarMoeda(projetado)}</div>
                        </div>
                    </div>
                </div>

            ) : (
                <div className='card-medidor'>
                    <div className='card-header-medidor font-titulo-medidor'>
                        <span className='text-[10px]' style={{ color: '#888888' }}>Mensal</span>
                        <h4 className='uppercase'>{titulo}</h4>
                    </div>
                    <p className='p-info-medidor font-titulo-medidor'>Sem dados no momento!</p>
                </div>
            )}
        </>
    );
}

export default GraficoMedidor